import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedNews from './components/FeaturedNews';
import TrendingSection from './components/TrendingSection';
import LatestArticles from './components/LatestArticles';
import HotTags from './components/HotTags';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黑料不打烊 - 娱乐圈深度爆料聚合平台',
    description: '全天候追踪娱乐圈最新黑料、明星丑闻与幕后真相',
    url: 'https://heiliaobudaying.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料不打烊',
      url: 'https://heiliaobudaying.com',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedNews />

          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="flex-1 min-w-0">
                  <LatestArticles />
                </div>
                <div className="w-full lg:w-80 flex-shrink-0">
                  <div className="space-y-5 sticky top-20">
                    <TrendingSection />
                    <HotTags />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}